<template>
  <!-- Tax Chat Log = หน้า Chat Logs เดิมในโหมดภาษี (logScope="tax")
       ต้องเป็นคอมโพเนนต์แยกจริง ๆ ไม่ใช่สอง route ชี้ component เดียวกัน
       มิฉะนั้น router จะ reuse instance เดิมและค่าฟิลเตอร์จะรั่วข้ามหน้า -->
  <LogMessage log-scope="tax" />
</template>

<script>
import LogMessage from './LogMessage.vue';

export default {
  name: 'TaxChatLog',
  components: { LogMessage },
};
</script>
